import { render } from "./ProfessionalSettingPage.vue?vue&type=template&id=712b7092"
import script from "./ProfessionalSettingPage.vue?vue&type=script&lang=js"
export * from "./ProfessionalSettingPage.vue?vue&type=script&lang=js"
script.render = render

export default script